module.exports = __webpack_public_path__ + "assets/fonts/card-pin.a482c7ed.svg";